import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropDown_Expression } from '@app/hcs-frontend';
import { DBDef_Expression, ExpressionOutput_Boolean, isUserPickableExpression } from '@app/hcs-shared';
import { ICONS, Preview } from '@app/styles';
import { ModuleFE_FloatingWindows, windowRect } from '@app/hcs-frontend/floating-window';
import { Button, ComponentSync, TS_Loader } from '@nu-art/thunderstorm-frontend';
import { _values, exists } from '@nu-art/ts-common';
import './Dialog_AssignOrderExpression.scss';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
/**
 * Floating dialog to assign an expression ID to an order, matching the KM flow used for disease values.
 */
export class Dialog_AssignOrderExpression extends ComponentSync {
    static show = (props) => {
        const model = {
            key: 'assign-order-expression',
            className: 'preview-window dialog__assign-order-expression',
            rect: { ...windowRect.thirdScreen_Middle(), height: undefined },
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Dialog_AssignOrderExpression, { ...props, onClose: cb })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedExpressionId ??= nextProps.expressionId;
        return state;
    }
    componentDidMount() {
        const expressionId = this.props.expressionId;
        if (!expressionId)
            return this.setState({ otherDependencies: true });
        ModuleFE_CollectionActions.check.usage({ dbKey: DBDef_Expression.dbKey, itemIds: [expressionId] }).execute((response) => {
            if (!response.dependencies)
                return this.setState({ otherDependencies: false });
            const itemDependencies = response.dependencies.dependencyMap[expressionId];
            const results = _values(itemDependencies);
            this.setState({ otherDependencies: results.length > 1 || results[0].length > 1 });
        }, (err) => {
            this.logError(err);
        });
    }
    expressionFilter = (exp) => {
        return exp.outputType === ExpressionOutput_Boolean
            && isUserPickableExpression(exp);
    };
    canSave = () => exists(this.state.selectedExpressionId)
        && this.state.selectedExpressionId !== this.props.expressionId;
    save = async () => {
        if (!this.canSave() || !this.state.selectedExpressionId)
            return;
        try {
            await this.props.onSave(this.state.selectedExpressionId);
            this.props.onClose();
        }
        catch (err) {
            this.logError(err);
        }
    };
    render() {
        return _jsxs(Preview.Root, { children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: "Assign order expression ID" }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.onClose }) })] });
    };
    render_Main = () => {
        return _jsx(Preview.Main, { children: _jsxs(Preview.MainColumn, { children: [_jsx(DropDown_Expression.selectable, { selected: this.state.selectedExpressionId, onSelected: exp => this.setState({ selectedExpressionId: exp._id }), limitItems: 50, queryFilter: this.expressionFilter }), this.render_DeleteExpressionMessage(), _jsx(Button, { variant: 'primary', onClick: this.save, disabled: !this.canSave(), children: "Save" })] }) });
    };
    render_DeleteExpressionMessage = () => {
        if (!exists(this.state.otherDependencies))
            return _jsx(TS_Loader, {});
        if (this.state.otherDependencies)
            return;
        return _jsx("div", { className: 'exp-dependencies-message', children: "The current expression does not have any other dependencies; re-assigning will also delete the current one." });
    };
}
//# sourceMappingURL=Dialog_AssignOrderExpression.js.map